<template>
	<div>
		<div class="page__header">
			<h1>Achievements</h1>
		</div>
	</div>
</template>

<script>

export default {
	data () {
		return {
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/views/_achievements.scss";
</style>
